import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import hexToRgba from "hex-to-rgba";
import { TouchableOpacity } from "react-native";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
/**
 * An UI component representing a practice item to be or already completed.
 *
 *
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̅̀̀̃̄̀̀̆̂̀̀̃̃̀̀̃̉̀̀̃̅̀̀̆̆̀̀̃̇̀̀̂̍̀̀̃̂̀̀̆̅̀̀̆̆̀̀̆̂̀̀̂̍̀̀̃̄̀̀̆̅̀̀̃̈̀̀̃̈̀̀̂̍̀̀̆́̀̀̃̃̀̀̃̆̀̀̆̃̀̀̂̍̀̀̃̃̀̀̃̇̀̀̆̂̀̀̃̀̀̀̃́̀̀̃̅̀̀̆̂̀̀̆̄̀̀̃̆̀̀̆̆̀̀̃́̀̀̃̆̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̈̀̀̃̀̀̀̃̈̀̀̂̍̀̀̃́̀̀̃̅̀̀̃́̀̀̃̅̀̀̃̅̀̀̃̂̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃̂̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃́̀̀̃̅̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̅̀̀̆̃̀̀̃̃̀̀̃̇̀̀̃̉̀̀̃̄̀̀̆́̀̀̃̃̀̀̂̍̀̀̆́̀̀̃̉̀̀̃̉̀̀̃̀̀̀̂̍̀̀̃̄̀̀̃̂̀̀̆̅̀̀̆̃̀̀̂̍̀̀̃̈̀̀̃̉̀̀̃̀̀̀̃̇̀̀̂̍̀̀̆̃̀̀̃̉̀̀̃̂̀̀̆̅̀̀̃́̀̀̆̅̀̀̆̅̀̀̃̆̀̀̆̆̀̀̆̆̀̀̆̂̀̀̆̆̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̈̀̀̃̀̀̀̃̈̀̀̂̍̀̀̃́̀̀̃̅̀̀̃́̀̀̃̅̀̀̃̄̀̀̃̄̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̄̀̀̃̇̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̀̀̀̃̇̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-9}
 */ export function PracticeItem(props) {
    var theme = useTheme().theme;
    var color = props.complete ? '#008689' : props.color;
    return /*#__PURE__*/ _jsx(TouchableOpacity, {
        "aria-label": "".concat(props.text, ". ").concat(props.complete ? 'completed' : ''),
        role: "button",
        onPress: props.onPress,
        disabled: props.complete,
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            spacing: 12,
            children: [
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        width: 35,
                        height: 35,
                        backgroundColor: hexToRgba(color !== null && color !== void 0 ? color : '#FF0000', 0.1),
                        borderRadius: 10,
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    children: /*#__PURE__*/ _jsx(Icon, {
                        name: props.complete ? 'check' : props.icon,
                        size: 18,
                        color: color
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    text: props.text,
                    style: [
                        {
                            flex: 1,
                            marginRight: 12
                        },
                        props.complete ? {
                            opacity: 0.7,
                            textDecorationLine: 'line-through'
                        } : null
                    ],
                    color: props.complete ? '#035759' : undefined,
                    size: 17,
                    weight: "semibold"
                }),
                props.complete ? null : /*#__PURE__*/ _jsx(Icon, {
                    name: "caret-right",
                    color: props.complete ? theme.color.gray500 : theme.color.primary100
                })
            ]
        })
    });
}
